export const SUGGESTED_PROJECT_NAMES_MAX_AMOUNT = 5;
